var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _g2, _rect, _g3, _path14, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 42,
    viewBox: "0 0 225 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0006 3.65393C78.9956 5.48089 78.2978 9.89605 78.4495 11.8753C82.5454 8.67808 84.8211 9.59156 88.0068 6.85111C90.5554 4.65876 89.6755 1.37022 88.917 0C88.6136 0.456741 87.0055 1.82696 83.0006 3.65393Z",
    fill: "#FF5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4411 17.4308V15.2771H36.6335V11.7834H54.6288V16.9762C54.6288 19.082 54.5092 21.2836 54.1741 22.9108H50.0103C50.3453 21.3554 50.4411 19.2017 50.4411 17.4308ZM43.5732 27.7447H35.7002V24.2509H55.7057V27.7447H47.7609V34.3015H43.5732V27.7447Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1584 32.5307H60.3232V20.4221H67.3586V15.3729H60.3232V11.903H71.4985V23.8441H64.4631V29.0847H70.637C72.4557 29.0847 73.5804 28.8454 74.3222 28.1754V11.5201H78.51V33.9425H74.3222V31.4777C73.5565 32.2435 72.2403 32.5307 70.1584 32.5307Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0129 16.5694V13.1713H87.9375V10.8979H92.0534V13.1713H95.9779V16.5694H92.1252C92.4363 19.3213 93.8721 20.4221 96.3608 20.8768V24.3227C93.8242 24.0116 91.3355 22.9587 90.0194 21.3793C88.6793 23.0065 86.0949 24.2987 83.6301 24.562V21.14C86.0709 20.6614 87.5307 19.3931 87.8657 16.5694H84.0129ZM102.463 11.5201V24.4184H98.2752V20.2067H95.1165V17.0001H98.2752V11.5201H102.463ZM85.1137 29.6112C85.1137 28.1515 85.7598 27.0985 86.8845 26.3328C88.4879 25.2081 91.0484 24.7055 94.0396 24.7055C97.0069 24.7055 99.6153 25.2081 101.195 26.3328C102.295 27.0985 102.965 28.1515 102.965 29.6112C102.965 31.047 102.295 32.0999 101.195 32.8657C99.6153 33.9904 97.0069 34.445 94.0396 34.445C91.0484 34.445 88.4879 33.9904 86.8845 32.8657C85.7598 32.0999 85.1137 31.047 85.1137 29.6112ZM89.2297 29.6112C89.2297 29.9462 89.4211 30.1855 89.7322 30.4248C90.4262 30.9034 91.9338 31.1188 94.0396 31.1188C96.1455 31.1188 97.6291 30.9034 98.347 30.4248C98.682 30.1855 98.8017 29.9462 98.8017 29.6112C98.8017 29.2762 98.682 28.9651 98.347 28.7497C97.6291 28.2711 96.1455 28.0797 94.0396 28.0797C91.9338 28.0797 90.4262 28.2711 89.7322 28.7497C89.4211 28.9651 89.2297 29.2762 89.2297 29.6112Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.887 21.0682V15.3729H108.11V11.903H120.027V20.6375C120.027 22.6476 119.883 25.0645 119.572 26.5721H115.456C115.743 25.0166 115.887 22.8151 115.887 21.0682ZM121.654 11.5201H125.842V20.1589H128.929V23.6526H125.842V33.9425H121.654V31.741C120.888 32.4828 119.596 32.7939 117.514 32.7939H107.559V29.348H110.048V19.7999H114.188V29.348H117.993C119.811 29.348 120.912 29.0847 121.654 28.4147V11.5201Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.345 15.2771H143.549C144.004 18.2445 146.803 19.7281 150.584 20.2546V23.7723C147.043 23.4612 143.262 22.0972 141.395 20.0871C139.529 22.0972 135.819 23.4373 132.23 23.7723V20.2546C135.987 19.752 138.763 18.2923 139.218 15.2771H132.493V11.7834H150.345V15.2771ZM139.289 28.7497H131.416V25.2799H151.422V28.7497H143.477V34.3015H139.289V28.7497Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.581 11.6637H163.793V14.655C163.793 18.388 165.42 19.9674 168.172 20.7092V24.2269C165.635 23.9398 163.027 22.7433 161.711 21.1639C160.466 22.8151 157.786 24.1312 155.178 24.4902V20.9964C158.002 20.2067 159.581 18.388 159.581 14.6789V11.6637ZM174.25 11.5201V24.5859H170.062V11.5201H174.25ZM156.901 28.9651V25.5192H174.25V34.3015H170.062V28.9651H156.901Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.084 13.3867V10.8979H188.272V13.3867H192.627V16.7369H179.753V13.3867H184.084ZM184.252 22.4801C184.252 23.1262 184.491 23.6287 184.874 23.9637C185.209 24.2748 185.688 24.4423 186.238 24.4423C186.765 24.4423 187.243 24.2748 187.578 23.9637C187.961 23.6287 188.2 23.1262 188.2 22.4801C188.2 21.8579 187.961 21.3314 187.578 20.9964C187.243 20.6853 186.765 20.5417 186.238 20.5417C185.688 20.5417 185.209 20.6853 184.874 20.9964C184.491 21.3314 184.252 21.8579 184.252 22.4801ZM180.28 22.4801C180.28 20.7332 181.021 19.3452 182.29 18.4359C183.319 17.6941 184.659 17.2873 186.238 17.2873C187.794 17.2873 189.158 17.6941 190.163 18.4359C191.431 19.3452 192.173 20.7332 192.173 22.4801C192.173 24.2269 191.431 25.6388 190.163 26.5242C189.636 26.9071 188.99 27.2182 188.296 27.4096V29.348H190.282C192.125 29.348 193.226 29.0847 193.967 28.3908V11.5201H198.155V33.9664H193.967V31.6931C193.202 32.4349 191.909 32.7699 189.804 32.7699H179.346V29.348H184.156V27.4096C183.462 27.2182 182.84 26.9071 182.29 26.5242C181.021 25.6388 180.28 24.2269 180.28 22.4801Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.401 28.4865C208.301 30.4727 205.668 32.1238 202.916 32.6503V29.0129C205.525 27.96 207.319 26.1653 207.319 19.9196V11.7834H211.483V19.9196C211.483 26.1653 213.254 27.9122 215.862 29.0129V32.6503C213.134 32.1478 210.622 30.4487 209.401 28.4865ZM217.37 11.5201H221.558V20.1589H224.645V23.6526H221.558V33.9425H217.37V11.5201Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 14.2438C0.00390625 10.9389 2.68307 8.25977 5.98798 8.25977V8.25977C9.29289 8.25977 11.972 10.9389 11.972 14.2438V33.6322C11.972 36.9371 9.29289 39.6163 5.98798 39.6163V39.6163C2.68307 39.6163 0.00390625 36.9371 0.00390625 33.6322V14.2438Z",
    fill: "url(#paint0_radial_477_7792)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2236C0 10.9258 2.67339 8.25244 5.97118 8.25244V8.25244C9.26897 8.25244 11.9424 10.9258 11.9424 14.2236V33.5461C11.9424 36.8439 9.26897 39.5173 5.97118 39.5173V39.5173C2.67339 39.5173 0 36.8439 0 33.5461V14.2236Z",
    fill: "url(#paint1_radial_477_7792)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_477_7792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 12,
    height: 32
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2236C0 10.9258 2.67339 8.25244 5.97118 8.25244V8.25244C9.26897 8.25244 11.9424 10.9258 11.9424 14.2236V33.5461C11.9424 36.8439 9.26897 39.5173 5.97118 39.5173V39.5173C2.67339 39.5173 0 36.8439 0 33.5461V14.2236Z",
    fill: "url(#paint2_radial_477_7792)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_477_7792)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.58236,
    cy: 16.1873,
    r: 1.78451,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 0.0425186,
    cy: 27.4097,
    r: 4.07182,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 10.2416,
    cy: 36.0268,
    r: 6.44375,
    fill: "#222222"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.682 9.85816C23.3451 7.52124 19.5562 7.52124 17.2193 9.85816L7.5857 19.4917C5.37508 21.7023 5.2556 25.2122 7.22726 27.5633C7.38101 27.7617 7.54894 27.9526 7.73108 28.1348L17.3646 37.7684C19.7016 40.1053 23.4905 40.1053 25.8274 37.7684C28.1643 35.4314 28.1643 31.6425 25.8274 29.3056L20.2624 23.7406L25.682 18.3209C28.0189 15.984 28.0189 12.1951 25.682 9.85816Z",
    fill: "url(#paint3_radial_477_7792)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_477_7792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8282 29.3057C28.1651 31.6427 28.1651 35.4316 25.8282 37.7685V37.7685C23.4913 40.1054 19.7024 40.1054 17.3654 37.7685L15.8454 36.2484C13.5084 33.9115 13.5085 30.1226 15.8454 27.7857L20.0768 23.5543L25.8282 29.3057Z",
    fill: "#DB3838"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_477_7792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 12,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00390625,
    y: 8.26025,
    width: 11.9681,
    height: 31.3565,
    rx: 5.98407,
    fill: "url(#paint4_radial_477_7792)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_477_7792)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_477_7792)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.683 9.85816C23.3461 7.52124 19.5572 7.52124 17.2202 9.85816L7.58668 19.4917C5.37877 21.6996 5.25688 25.2036 7.22101 27.5547C7.37662 27.7562 7.54685 27.9502 7.73171 28.135L17.3653 37.7686C19.7022 40.1055 23.4911 40.1055 25.828 37.7686C28.1649 35.4317 28.1649 31.6428 25.828 29.3059L20.263 23.7409L25.683 18.3209C28.0199 15.984 28.0199 12.1951 25.683 9.85816Z",
    fill: "url(#paint5_radial_477_7792)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8272 29.3057C28.1641 31.6427 28.1641 35.4316 25.8272 37.7685V37.7685C23.4903 40.1054 19.7014 40.1054 17.3645 37.7685L16.424 36.828C13.767 34.171 13.767 29.8631 16.424 27.2061L20.0758 23.5543L25.8272 29.3057Z",
    fill: "#DD4A4A"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_477_7792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 23,
    height: 22
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0014 9.32573C19.8786 7.44853 23.2556 7.78199 25.5442 10.0705V10.0705C27.8327 12.3591 28.1662 15.7361 26.289 17.6133L15.2763 28.6259C13.3991 30.5031 10.0221 30.1697 7.73359 27.8811V27.8811C5.44504 25.5926 5.11158 22.2156 6.98877 20.3384L18.0014 9.32573Z",
    fill: "url(#paint6_radial_477_7792)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_477_7792)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 18.4163,
    cy: 24.6561,
    r: 5.66926,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 21.1003,
    cy: 10.634,
    r: 3.79069,
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_477_7792",
    x: 14.0928,
    y: 23.5542,
    width: 14.9266,
    height: 16.3264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.43831,
    dy: 0.359577
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.898943
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_477_7792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_477_7792",
    x: 1.47959,
    y: 4.83967,
    width: 28.2787,
    height: 37.9476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.0886
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6329
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_477_7792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_477_7792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.31504 4.66308) rotate(71.616) scale(107.323 46.6731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.58941 6.84351) rotate(69.7923) scale(60.6971 26.4162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.58941 6.84351) rotate(69.7923) scale(60.6971 26.4162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85409 -3.90047) rotate(67.4365) scale(30.9081 23.7898)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.00835 0.685747) rotate(68.4056) scale(50.807 22.0952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85506 -3.90056) rotate(67.437) scale(30.9082 23.7894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_477_7792",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7832 3.7049) rotate(109.24) scale(42.1347 20.9586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42B5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341488,
    stopColor: "#3CAAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F54AA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1fe7a802802dd400b1abc6d347d3115d.svg";
export { ForwardRef as ReactComponent };